var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSettings({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_65",
    "data-name": "Rectangle 65",
    width: 40,
    height: 40,
    transform: "translate(213 252)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_27",
    "data-name": "Mask Group 27",
    transform: "translate(-213 -252)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon_core-settings",
    "data-name": "Icon core-settings",
    transform: "translate(220.365 259.623)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_78",
    "data-name": "Path 78",
    d: "M15.345,11.813a4.3,4.3,0,1,0,4.3,4.3A4.3,4.3,0,0,0,15.345,11.813Zm0,7.028a2.733,2.733,0,1,1,2.733-2.733A2.733,2.733,0,0,1,15.345,18.841Z",
    transform: "translate(-2.986 -3.269)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79",
    "data-name": "Path 79",
    d: "M23.075,16.076,21.524,14.8a9.424,9.424,0,0,0,0-3.921L23.075,9.6A.973.973,0,0,0,23.3,8.36L21.708,5.6a.973.973,0,0,0-1.188-.426l-1.882.705a9.373,9.373,0,0,0-3.394-1.962l-.33-1.98a.973.973,0,0,0-.963-.816H10.767a.973.973,0,0,0-.963.816l-.33,1.98A9.373,9.373,0,0,0,6.08,5.883L4.2,5.177A.973.973,0,0,0,3.01,5.6L1.419,8.361A.973.973,0,0,0,1.644,9.6l1.551,1.276a9.424,9.424,0,0,0,0,3.921L1.643,16.076a.973.973,0,0,0-.225,1.242L3.01,20.074A.973.973,0,0,0,4.2,20.5L6.08,19.8a9.373,9.373,0,0,0,3.394,1.962l.33,1.98a.973.973,0,0,0,.963.816h3.183a.973.973,0,0,0,.963-.816l.33-1.98A9.373,9.373,0,0,0,18.638,19.8l1.882.705a.973.973,0,0,0,1.188-.426L23.3,17.317a.973.973,0,0,0-.225-1.241ZM20.6,18.864l-2.348-.88-.356.358a7.807,7.807,0,0,1-3.545,2.049l-.488.129-.412,2.472H11.264l-.412-2.472-.488-.129a7.807,7.807,0,0,1-3.545-2.049l-.356-.358-2.349.88-1.1-1.9,1.934-1.592-.132-.487a7.853,7.853,0,0,1,0-4.1l.132-.487L3.019,8.712l1.1-1.9,2.348.88.356-.358a7.807,7.807,0,0,1,3.545-2.049l.488-.129.412-2.472h2.191l.412,2.472.488.129A7.807,7.807,0,0,1,17.9,7.336l.356.358,2.348-.88,1.1,1.9L19.765,10.3l.132.487a7.853,7.853,0,0,1,0,4.1l-.132.487L21.7,16.966Z",
    transform: "translate(0 0)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettings);
export default __webpack_public_path__ + "static/media/settings.15bae01ab678b1e48267dbcadf01ca75.svg";
export { ForwardRef as ReactComponent };